import { useForm } from '@mantine/form'
import { modals } from '@mantine/modals'
import usePaginate from '@v2/commons/hooks/pagination/usePagination.hook'
import showModalNotificationError from '@v2/commons/modals/ModalNotification/showModalNotificationError'
import { filterUndefinedValues } from '@v2/commons/utils/filterUndefinedValues'
import { useRouter } from '@v2/commons/utils/navigation'
import { openCreateClinicModal } from '@v2/domains/clinics/components/CreateClinicModal/CreateClinicModal.component'
import { DEFAULT_ROUTES } from '@v2/domains/routing/types/routing.types'
import { getRoutePath } from '@v2/domains/routing/utils/route.utils'
import { useEffect, useState } from 'react'

import { useGetLocationsQuery } from '../api/location.api'
import { ILocationsFilter } from '../location.types'

export const useLocations = () => {
  const { handlePaginate, paginationLimitField, tablePage, page } =
    usePaginate()
  const [filtersOpen, setFiltersOpen] = useState(false)

  const [activeProgramButtonFilter, setActiveProgramButtonFilter] = useState('')

  const locationsFiltersForm = useForm<ILocationsFilter>({
    initialValues: {},
    mode: 'uncontrolled',
    onValuesChange: (values, previousValues) => {
      handlePaginate(0)
      return values
    },
  })

  const { data, isLoading, isSuccess, isFetching, isError, refetch } =
    useGetLocationsQuery({
      ...filterUndefinedValues(locationsFiltersForm.getValues()),
    })

  const locationsWithProvidersAsString =
    typeof data !== 'undefined'
      ? {
          ...data,
          records: data?.records.map((location) => {
            return {
              ...location,
              providers: [
                ...new Set(
                  location.providers.map((provider) =>
                    provider?.person
                      ? `${provider.person.firstName} ${provider.person.lastName}`
                      : '',
                  ),
                ),
              ].join(', '),
            }
          }),
        }
      : undefined

  useEffect(() => {
    if (isError) {
      showModalNotificationError({
        subtitle: 'Error fetching locations',
        buttonText: 'Retry',
        onClickBtn: () => refetch(),
      })
    } else {
      modals.closeAll()
    }
  }, [isError])

  const router = useRouter()

  const handleEditClinic = (clinicId: string) => {
    router.push(`${getRoutePath(DEFAULT_ROUTES.CLINICS)}/${clinicId}`)
  }

  const handleCreateUser = () => {
    openCreateClinicModal()
  }

  return {
    locations: locationsWithProvidersAsString,
    isLoading,
    isFetching,
    isSuccess,
    handlePaginate,
    handleEditClinic,
    handleCreateUser,
    paginationLimitField,
    tablePage,
    isError,
    locationsFiltersForm,
    setFiltersOpen,
    filtersOpen,
    activeProgramButtonFilter,
    setActiveProgramButtonFilter,
  }
}
